module.exports = __webpack_public_path__ + "static/frontend-6a6de854faa7140f2e833a284bafa475.svg";